import { cowHead } from "@lucide/lab"
import {
  CircleDot,
  CircleFadingArrowUp,
  Factory,
  FileChartColumn,
  FileCode,
  Gauge,
  Home,
  Icon,
  Settings,
  Sheet,
  Truck,
  Zap,
} from "lucide-react"

import lightLogoUrl from "../assets/Logo.png"
import darkLogoUrl from "../assets/SE_Wide_White.png"

import AuthWrap from "./AuthWrap.tsx"
import DevApiTargetSwitcher from "./DevApiTargetSwitcher.tsx"
import NavButton from "./NavButton.tsx"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
} from "./ui/sidebar.tsx"
import UserInfo from "./UserInfo.tsx"

export default function AppSidebar() {
  return (
    <Sidebar collapsible="offcanvas" variant="inset">
      <SidebarHeader>
        <img src={lightLogoUrl} alt="Sagepoint Logo" className="w-[200px] mt-3 dark:hidden" />
        <img src={darkLogoUrl} alt="Sagepoint Logo" className="w-[200px] mt-3 hidden dark:block" />
      </SidebarHeader>
      <SidebarContent className="mt-4">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <NavButton to="/" label="Home" icon={<Home />} />
              <NavButton to="/incentives" label="Incentives" icon={<Gauge />} />
              <NavButton to="/kpis" label="KPIs" icon={<Sheet />} />
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel>Dashboards</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <NavButton
                to="/dashboards/BCO"
                label="BC Organics"
                icon={<Icon iconNode={cowHead} />}
              />
              <NavButton
                to="/dashboards/Digesters"
                label="BCO Digesters"
                icon={<Icon iconNode={cowHead} />}
              />
              <NavButton to="/dashboards/SPL" label="SPL Farm" icon={<Truck />} />
              <NavButton to="/dashboards/For-Hire" label="SPL For Hire" icon={<Truck />} />
              <NavButton to="/dashboards/PLTH" label="Plumb Thicket" icon={<Factory />} />
              <NavButton to="/dashboards/LWRN" label="Lawrence" icon={<Factory />} />
              <NavButton to="/dashboards/PEPL" label="Peoples" icon={<Zap />} />
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel>Data Points</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <NavButton to="/datapoints/reports" label="Reports" icon={<FileChartColumn />} />
              <NavButton
                to="/datapoints/report-runs"
                label="Report Runs"
                icon={<CircleFadingArrowUp />}
              />
              <AuthWrap role="Datapoint.Admin">
                <NavButton to="/datapoints/defs" label="Definitions" icon={<CircleDot />} />
              </AuthWrap>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <AuthWrap role="KPI.Admin,Logistics.Admin,Spec.Read">
          <SidebarGroup>
            <SidebarGroupLabel>Admin</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                <AuthWrap role="KPI.Admin">
                  <NavButton to="/admin/kpi" label="KPI Admin" icon={<Settings />} />
                </AuthWrap>
                <AuthWrap role="Logistics.Admin">
                  <NavButton to="/admin/logistics" label="Logistics Admin" icon={<Settings />} />
                </AuthWrap>
                <AuthWrap role="Spec.Read">
                  <NavButton to="/admin/api-docs" label="API Docs" icon={<FileCode />} />
                </AuthWrap>
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </AuthWrap>
      </SidebarContent>
      <SidebarFooter>
        <DevApiTargetSwitcher />
        <UserInfo />
      </SidebarFooter>
    </Sidebar>
  )
}
